import { render, staticRenderFns } from "./quickTab.vue?vue&type=template&id=560eb5f4&"
import script from "./quickTab.vue?vue&type=script&lang=js&"
export * from "./quickTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports